<template>
  <div>
    <button
      v-if="canSaveSelectedApplication"
      class="btn btn-secondary btn-sm mr-1"
      @click="updateApplication"
    >
      Save
    </button>
    <button class="btn btn-danger btn-sm" @click="cancelEditing">Cancel</button>
  </div>
</template>

<script>
export default {
  props: {
    canSaveSelectedApplication: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      }
    },
    updateApplication: {
      type: Function,
      required: true,
      default: () => {}
    },
    cancelEditing: {
      type: Function,
      required: true,
      default: () => {}
    }
  }
};
</script>
